import type { IIntegrations } from "store/integrationsStore";
import { IntegrationStatus } from "store/integrationsStore";
import type { IUser } from "types";

/**
 * A template is in sync as long as its integration exists and is connected,
 * regardless of whether the user who connected it is listed in the company members.
 */
export const isIntegrationActive = (integration: IIntegrations | null | undefined): integration is IIntegrations =>
    integration?.status === IntegrationStatus.CONNECTED;

/**
 * Who the integration belongs to: the connected Google account email when the backend provides it,
 * otherwise the name of the user who connected it, falling back to the Crealo team label when that user
 * is not in the company members list (Crealo staff are hidden from it on client companies) or has no name.
 */
export const getIntegrationAuthorName = (
    integration: Pick<IIntegrations, "connectedBy" | "accountEmail">,
    users: IUser[],
    t: (key: string) => string,
) => {
    if (integration.accountEmail) return integration.accountEmail;
    const user = users.find((u) => u.userId === integration.connectedBy);
    const name = [user?.firstname, user?.lastname]
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(" ");
    return name || t("PartnerStatements.CrealoTeam");
};
